<template>
  <w-input
    placeholder="********"
    outlined
    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
    :type="showPassword ? 'text' : 'password'"
    :model="model"
    @click:append="showPassword = !showPassword"
  />
</template>

<script>
import { WInput } from '@witkac/vuetify-components';

// @vuese
// Input hasła
// @group forms
export default {
  components: { WInput },
  props: {
    // @vuese schema hasła
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPassword: false
    };
  }
};
</script>
